import React, { type JSX } from "react";
import { twMerge } from "tailwind-merge";

import { SupText } from "../../../components/UI/Text";
import SupXSmall from "../../../icons/XSmall";
import SupCheck from "../../../icons/Check";

interface SummaryProps {
  className?: string;
  variant: "info" | "warning" | "error" | "success";
  icon?: JSX.Element;
}

const ICONS = {
  info: <SupText variant="button">!</SupText>,
  warning: <SupText variant="button">!</SupText>,
  success: <SupCheck width={20} height={20} />,
  error: <SupXSmall width={20} height={20} />,
} as const;

const VARIANTS = {
  info: "text-neutral-900 bg-info-500",
  warning: "text-neutral-50 bg-warning-600",
  success: "text-neutral-50 bg-success-600",
  error: "text-neutral-50 bg-error-700",
} as const;

export function SupSummary({ variant, icon, className }: SummaryProps) {
  return (
    <span className={twMerge("sup-summary-indicator inline-flex justify-center items-center h-5 w-5 rounded-full", VARIANTS[variant], className)}>{icon ?? ICONS[variant]}</span>
  );
}
